export const pathologiesGrandMotherSlug = () => `/pathologies/`;

export const pathologiesMotherSlug = (categorySlug) => `/pathologies/${categorySlug}/`;

export const pathologiesDaughterSlug = (categorySlug, pathologySlug) => `/pathologies/${categorySlug}/${pathologySlug}/`;
